import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

type Props = {
    handleCloseForm: () => void
    handleSubmit: () => void
    submitButtonText?: string
    hideCancelButton?: boolean
    cancelButtonText?: string
    isLoading?: boolean
}

const ProjectFormFooter = (props: Props) => {
  return (
    <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                padding={"var(--mui-modal-footer-padding)"}
                bgcolor={"var(--mui-modal-footer-background)"}
                sx={{
                    borderBottomLeftRadius: "var(--mui-modal-border-radius)",
                    borderBottomRightRadius: "var(--mui-modal-border-radius)",
                }}>
                <Box display={"flex"} gap={1}></Box>
                <Box display={"flex"} gap={1}>
                    {!props.hideCancelButton && (
                        <Button variant="text" onClick={props.handleCloseForm}>
                            {props.cancelButtonText || "Cancel"}
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        color="statiqOrange"
                        loading={props.isLoading}
                        sx={{
                            fontSize: "15px",
                            fontWeight: "500",
                            width: "100px",
                        }}
                        onClick={() => {
                            props.handleSubmit()
                        }}>
                        {props.submitButtonText || "Next"}
                    </Button>
                </Box>
            </Box>
  )
}

export default ProjectFormFooter